<template>
  <div>
    <template v-if="integrationSystem == 'Manual'">
      <span class="badge badge-dark"
        >Connect API</span
      >
    </template>
    <template v-else-if="integrationSystem == 'WooCommerceDirect'">
      <span class="badge badge-primary"
        >WooCommerce</span
      >
    </template>
    <template v-else-if="integrationSystem == 'ShopifyDirect' || integrationSystem == 'ShopifyDirect_Simple'">
      <span class="badge badge-success"
        >Shopify</span
      >
    </template>
    <template v-else-if="integrationSystem == 'CartRoverThirdParty'">
      <span class="badge badge-warning"
        >CartRover (Pass-Through)</span
      >
    </template>
    <template v-else-if="integrationSystem == 'BigCommerce_Direct_StoreAPI'">
      <span class="badge badge-warning"
        >BigCommerce (StoreAPI)</span
      >
    </template>
    <template v-else-if="integrationSystem == 'BrightPearl'">
      <span class="badge badge-warning"
        >BrightPearl</span
      >
    </template>
    <template v-else-if="integrationSystem == 'FtpImport'">
      <span class="badge badge-secondary"
        >(S)FTP</span
      >
    </template>
    <template v-else>
      <span class="badge badge-info"
        >ShipStation (Pass-Through)</span
      >
    </template>
  </div>
</template>

<script lang="js">
export default {
  props: {
    integrationSystem: {
      required: true
    }
  }
}
</script>

<style>

</style>
